import React, { Component } from 'react';
import './style.css';

const TS = 70;
const DS = 15;

export default class TypewriterQuotes extends React.Component {
  state = {
    text: '',
    isDeleting: false,
    loopNum: 0,
    typingSpeed: TS,
  };

  timeouts = [];

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.handleType();
  }

  componentWillUnmount() {
    for (const cb of this.timeouts) {
      clearTimeout(cb);
    }
  }

  handleType = () => {
    const { dataText } = this.props;
    const { isDeleting, loopNum, text, typingSpeed } = this.state;
    const i = loopNum % dataText.length;
    const fullText = dataText[i];

    this.setState({
      text: isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1),
      restText: isDeleting
        ? fullText.substring(text.length - 1)
        : fullText.substring(text.length + 1),
      typingSpeed: isDeleting ? DS : TS,
    });

    if (!isDeleting && text === fullText) {
      this.timeouts.push(
        setTimeout(
          () => this.setState({ isDeleting: true }),
          text.length * DS * 0.9
        )
      );
    } else if (isDeleting && text === '') {
      this.setState({
        isDeleting: false,
        loopNum: loopNum + 1,
      });
    }

    this.timeouts.push(setTimeout(this.handleType, typingSpeed));
  };

  render() {
    return (
      <div className="hp-quotes-wrapper">
        <div className="hp-quote">
          <div className="hp-quote-mark hp-quote-mark--top" />
          <div className="hp-quote-mark hp-quote-mark--bottom" />
          {this.state.text.split('').map((letter, idx) => (
            <span key={idx} className="hp-quote__text">
              {letter}
            </span>
          ))}
          <span className="hp-quote__rest-text">{this.state.restText}</span>
        </div>
      </div>
    );
  }
}
